module.exports = __webpack_public_path__ + "media/images/x-twitter-a6dbfa1b99a203035ecc7774f2f02583.svg";